import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import type { TeamMemberData } from '../TeamMemberCard';
import { TeamMemberCard } from '../TeamMemberCard';

interface TeamMemberListProps extends ComponentPropsWithoutRef<'div'> {
  teamMembers: TeamMemberData[];
  cardClassName?: string;
  cardContentCentered?: boolean;
  photoIsInBlackFrame?: boolean;
}

const TeamMemberList = ({
  teamMembers,
  className,
  cardClassName,
  cardContentCentered,
  photoIsInBlackFrame,
}: TeamMemberListProps) => {
  return (
    <ul className={classNames('grid md:grid-cols-2 gap-y-12 gap-x-10', className)}>
      {teamMembers.map((teamMember) => {
        return (
          <li key={teamMember.id}>
            <TeamMemberCard
              teamMember={teamMember}
              className={cardClassName}
              contentCentered={cardContentCentered}
              photoIsInBlackFrame={photoIsInBlackFrame}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default TeamMemberList;
